import { formatDate } from '@/utils/formatters';
import { PlanCards } from './PlanCards';
import { SegmentedControl } from './SegmentedControl';
import { SectionHeading } from './SectionHeading';
import { VIGENCIA_OPTIONS } from './constants';
import type { SubscriptionModalFormState } from './useSubscriptionModalForm';

interface PlanoSectionProps {
  form: SubscriptionModalFormState;
  disabled?: boolean;
}

// Seção "① Plano e ciclo" (modo Padrão) / "① Plano e vigência" (modo Enterprise).
export function PlanoSection({ form, disabled }: PlanoSectionProps) {
  const isEnterprise = form.planoCard === 'enterprise';
  const showCiclo = form.planoCard === 'basico' || form.planoCard === 'profissional';

  return (
    <div className="space-y-3">
      <SectionHeading
        num={1}
        tema={form.tema}
        title={isEnterprise ? 'Plano e vigência' : 'Plano e ciclo'}
      />
      <PlanCards selected={form.planoCard} onSelect={form.setPlanoCard} disabled={disabled} />

      {showCiclo && (
        <SegmentedControl
          aria-label="Ciclo"
          tema="azul"
          value={form.ciclo}
          onChange={form.setCiclo}
          disabled={disabled}
          options={[
            { value: 'mensal', label: 'Mensal' },
            { value: 'anual', label: 'Anual' },
          ]}
        />
      )}

      {isEnterprise && (
        <div className="flex flex-wrap items-center gap-3">
          <SegmentedControl
            aria-label="Vigência"
            tema="verde"
            value={form.vigenciaAnos}
            onChange={form.setVigenciaAnos}
            disabled={disabled}
            options={VIGENCIA_OPTIONS.map((o) => ({ value: o.anos, label: o.label }))}
          />
          <span className="text-sm text-text-secondary">
            até {formatDate(form.vigenciaEnd.toISOString())}
          </span>
        </div>
      )}
    </div>
  );
}
